import React, { useState, Fragment, memo } from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import { KeyboardArrowDown, KeyboardArrowRight } from '@material-ui/icons'

import { CookieDetailsTable } from '..'

import { useTranslation } from 'react-i18next'
import useCookieBanner from 'hooks/useCookieBanner'
import styles from './styles'

const CookieDetailsCard = ({ categoryId }) => {
  const { t } = useTranslation()
  const { banner } = useCookieBanner()
  const [open, setOpen] = useState(false)
  const classes = styles()

  let cookiesByCategory = []
  if (banner?.classification && categoryId) {
    const category = banner.classification.find((c) => c.id === categoryId)
    cookiesByCategory = category?.cookies || []
  }

  const toggleOpen = () => setOpen((prev) => !prev)

  return (
    <Box className={classes.root}>
      <Box
        className={`${classes.header} ${!open ? classes.headerClosed : ''}`}
        onClick={toggleOpen}
      >
        <Grid container>
          <Grid item xs={12} sm={9}>
            <Typography className={classes.title}>
              {t('card.cookiesDetails')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} className={classes.toggleArea}>
            <Typography variant="caption" className={classes.toggleLabel}>
              {t('card.showCookies')}
            </Typography>
            {open ? (
              <KeyboardArrowDown fontSize="small" />
            ) : (
              <KeyboardArrowRight fontSize="small" />
            )}
          </Grid>
        </Grid>
      </Box>
      {open && (
        <Fragment>
          <Box className={classes.cookiesContainer}>
            {cookiesByCategory.map((cookie) => (
              <Box key={cookie.id || cookie.name} className={classes.cookieBox}>
                <CookieDetailsTable cookie={cookie} />
              </Box>
            ))}
          </Box>
        </Fragment>
      )}
    </Box>
  )
}

export default memo(CookieDetailsCard)
